import React from 'react';
import './Header.scss';
import HeaderDecoration, { IHeaderDecorationProps } from './HeaderDecoration';
import HeaderLink, { IHeaderLinkProps } from './HeaderLink';
import HeaderSubtitle, { IHeaderSubtitleProps } from './HeaderSubtitle';
import HeaderTitle, { IHeaderTitleProps } from './HeaderTitle';

export interface IHeaderProps
    extends IHeaderTitleProps,
        IHeaderDecorationProps,
        IHeaderSubtitleProps {
    headerLinkProps?: IHeaderLinkProps;
}

const Header = ({
    titleText,
    titleClassName,
    subtitleText,
    iconColor = 'ui-orange',
    iconSize = 'medium',
    iconType,
    picture,
    shouldNotModifyIcon,
    iconBottomSpacing,
    headerLinkProps,
    isLoading,
}: IHeaderProps) => {
    return (
        <div className="auth-lib__header eds-text--left eds-l-mar-bot-10">
            <div>
                <HeaderDecoration
                    iconColor={iconColor}
                    iconSize={iconSize}
                    iconType={iconType}
                    picture={picture}
                    shouldNotModifyIcon={shouldNotModifyIcon}
                    iconBottomSpacing={iconBottomSpacing}
                    isLoading={isLoading}
                />

                <HeaderTitle
                    titleText={titleText}
                    titleClassName={titleClassName}
                />
                <HeaderSubtitle subtitleText={subtitleText} />
            </div>

            {headerLinkProps && <HeaderLink {...headerLinkProps} />}
        </div>
    );
};

export default Header;
